import React from 'react';
import { getContext } from 'common';
import _merge from 'lodash/merge';
import styled from './styles';

export interface SpinnerErrorMessageProps extends React.ComponentPropsWithRef<'div'> {
  /** Text content */
  text?: string;
  /** To override the theme please refer to the "Readme" tab to learn more. */
  theme?: any;
}

/**
 * Uncontrolled SpinnerErrorMessage.
 * Any other props than the `text` and `theme` props will be provided to the root element.
 * To get the ref of the outermost element use `ref` prop. [Read React useRef hook documentation](https://reactjs.org/docs/hooks-reference).
 */
const SpinnerErrorMessage = React.forwardRef<HTMLElement, SpinnerErrorMessageProps>((props: SpinnerErrorMessageProps, ref) => getContext(({ RTL, theme }) => {
  const {
    text,
    theme: propTheme,
    ...otherProps
  } = props;
  const resolvedTheme = _merge({}, { color: theme.TEXT_INPUT.OUTLINED.error.border, propTheme });

  return (
    <styled.ErrorMessage ref={ref} $theme={resolvedTheme} $rtl={RTL} {...otherProps}>
      {text}
    </styled.ErrorMessage>
  );
}));

SpinnerErrorMessage.displayName = 'SpinnerErrorMessage';

SpinnerErrorMessage.defaultProps = {
  text: '',
  theme: {}
};

export default SpinnerErrorMessage;
